import styled from "styled-components";

const Card = styled.div`
  border-radius: 8px;
  padding: ${(props) => (props.padding ? props.padding : "24px")};
  background-color: ${(props) => (props.bg ? props.bg : "#fff")};
  border: ${(props) => (props.border ? "1px solid #e2e2ea" : "none")};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
    0px 25px 35px 0px rgba(0, 0, 0, 0.03);
  position: relative;

  .content {
    gap: 4px;
  }

  .title {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.5px;
    color: ${(props) => (props.titleColor ? props.titleColor : "#07070c")};
  }

  .description {
    font-size: ${(props) =>
      props.descriptionSize ? props.descriptionSize : 14}px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px;
    color: var(--grey_5);
    text-align: left;
  }

  .floatingICon {
    position: absolute;
    top: 30px;
    right: 35px;
    transform: translate(50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  button {
    background-color: var(--secondary);
    color: #fff;
    font-size: 14px;
    font-weight: 450;
    padding: 8px 14px;
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: var(--transition_default);
    justify-self: flex-end;

    &:hover {
      background-color: var(--primary_light);
    }

    &.tutorialBtn {
      background: #fff0eb;
      border: 1px solid #ff6436;
      color: #ff6436;

      &:hover {
        background: rgba(255, 100, 54, 0.1);
      }
    }

    &.secondaryBtn {
      background: var(--primary);
      color: #fff;

      &:hover {
        background: var(--primary_light);
      }
    }
  }

  @media screen and (max-width: 768px) {
    min-width: 100%;
    width: 100%;
    max-width: 100%;
  }
`;

const ContentCard = ({
  header,
  content,
  buttons,
  bg,
  floatingIcon,
  actionIcon,
  descriptionSize,
  className,
  onClick,
}) => {
  return (
    <Card
      bg={bg}
      descriptionSize={descriptionSize}
      className={className}
      onClick={(e) => {
        if (!onClick) return;
        e.stopPropagation();
        onClick();
      }}
    >
      {floatingIcon && (
        <img src={floatingIcon} alt="floatingIcon" className="floatingICon" />
      )}
      <div className="flexColumn alignStart gap8">
        <div className="fullWidth flexRow alignCenter justifySpaceBetween">
          <div className="title">{header}</div>
          {actionIcon && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                onClick();
              }}
            >
              {actionIcon}
            </div>
          )}
        </div>
        <p className="description">{content}</p>
      </div>
      {buttons && (
        <div className="fullWidth flexRow alignCenter justifySpaceBetween gap8">
          {buttons?.map((button, index) => (
            <button
              key={index}
              onClick={button.onClick}
              className={button.className}
            >
              {button.buttonIcon && button.buttonIcon}
              {button.text}
            </button>
          ))}
        </div>
      )}
    </Card>
  );
};

export default ContentCard;
